// extracted by mini-css-extract-plugin
export default {"container":"FilterWarningIcon_container__1Quli","icon":"FilterWarningIcon_icon__Nbm8I"};